const modal = document.getElementById("modalCarousel");
const btns = document.querySelectorAll(".openModal");
const btnMobile = document.querySelector(".openModalMobile");
const span = document.querySelector(".close");
const dots = document.querySelectorAll(".dot");
const slides = document.querySelectorAll(".slide");

btns.forEach((btn, index) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    currentSlide(index);
    modal.style.display = "block";
    document.body.classList.add("modal-open");
  });
});

btnMobile.addEventListener("click", (e) => {
  e.preventDefault();
  modal.style.display = "block";
  document.body.classList.add("modal-open");
});

span.addEventListener("click", () => {
  modal.style.display = "none";
  document.body.classList.remove("modal-open"); 
});

window.addEventListener("click", (event) => {
  if (event.target === modal) {
    modal.style.display = "none";
    document.body.classList.remove("modal-open"); 
  }
});

function currentSlide(index) {
  slides.forEach((slide) => {
    slide.style.display = "none";
  });
  dots.forEach((dot) => {
    dot.classList.remove("active");
  });
  slides[index].style.display = "flex";
  dots[index].classList.add("active");
}

currentSlide(0);

dots.forEach((dot, index) => {
  dot.addEventListener("click", () => {
    currentSlide(index);
  });
});
